<template>
    <div>
        <p class="listLength">共计 <span>{{Total}}条</span></p>
        <LoadingFooter :finished="finished" v-model='loading' @load="onLoad" @scroll="$Bus.$emit('IsSee',false)">
            <div style="padding-top: 8vw;">
                <div class="items IsLoad" v-for="(item, index) in list" :key="index">
                    <div class="itemTopBox">
                        <div>
                            <span>入库单号</span>
                            <span>{{item.DH}}</span>
                        </div>
                        <div>
                            <span>供应商</span>
                            <span>{{item.GYSMC}}</span>
                        </div>
                        <div>
                            <span>入库日期</span>
                            <span>{{item.RQ}}</span>
                        </div>
                        <div>
                            <span>设备名称</span>
                            <span>{{item.SBMC}}</span>
                        </div>
                        <div>
                            <span>总金额</span>
                            <span>{{item.ZJE}}</span>
                        </div>
                        <div>
                            <span>联系人</span>
                            <span>{{item.LXRXM}}</span>
                        </div>
                        <div>
                            <span>批准人</span>
                            <span>{{item.PZRXM}}</span>
                        </div>
                        <div>
                            <span>采购员</span>
                            <span>{{item.CGYXM}}</span>
                        </div>
                        <div>
                            <span>发票编号</span>
                            <span>{{item.FPBH}}</span>
                        </div>
                        <div>
                            <span>批准号</span>
                            <span>{{item.PZH}}</span>
                        </div>
                        <div>
                            <span>审核状态</span>
                            <span :class="item.SHZT == '1' ? 'statusPass' : 'statusWait'">
                                {{item.SHZT == '1' ? '已审核' : '待审核'}}
                            </span>
                        </div>
                        <div v-if="item.BZ">
                            <span>备注</span>
                            <span>{{item.BZ}}</span>
                        </div>
                    </div>
                    <div class="itemBottomBox">
                        <!-- 审核：仅未审核时显示 -->
                        <div v-if="item.SHZT != '1'" class="btn-audit" @click.stop="auditItem(item, index)">审核</div>
                        <!-- 明细 -->
                        <div class="btn-detail" @click.stop="viewDetail(item)">明细</div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="menu" key="0" v-show="IsSee">
                    <Field title="验收单号" placeholder="请输入" :text='search.DH'
                        @onMessage="value => search.DH = value" />
                    <Field title="供应商" placeholder="请输入供应商编号或名称" :text='search.GYSMC'
                        @onMessage="value => search.GYSMC = value" />
                    <Field title="设备名称" placeholder="请输入设备名称" :text='search.SBMC'
                        @onMessage="value => search.SBMC = value" />
                    <Field title="开始时间" placeholder="请选择" type="calendar" :text='search.StartDate'
                        @onMessage="value => search.StartDate = value" />
                    <Field title="结束时间" placeholder="请选择" type="calendar" :text='search.EndDate'
                        @onMessage="value => search.EndDate = value" />
                    <Field title="审核状态" placeholder="请选择" type="tabs" :tabs="['全部','待审核','已审核']"
                        :text='search.SHZTLabel' @onMessage="value => onSHZTChange(value)" />
                    <div class="search" @click="serach">查询</div>
                </div>
            </transition>
        </LoadingFooter>
    </div>
</template>

<script>
    import Field from '../field/field'
    import LoadingFooter from '../loadingFooter/loadingFooter'
    export default {
        name: 'YrkList',
        components: {
            Field,
            LoadingFooter
        },
        props: {
            IsSee: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                list: [],
                Total: 0,
                pageIndex: 1,
                search: {
                    DH: '',
                    GYSMC: '',
                    SBMC: '',
                    StartDate: '',
                    EndDate: '',
                    SHZT: '',       // '' 全部 / '0' 待审核 / '1' 已审核
                    SHZTLabel: '全部'
                },
                loading: true,
                finished: false
            }
        },
        mounted() {
            this.loading = true;
            this.finished = false;
            this.list = [];
            this.loadDataDefault();
        },
        methods: {
            loadDataDefault() {
                this.$post('api/CheckIncoming/GetRKList', {
                    PageIndex: this.pageIndex,
                    PageSize: 10,
                    DH: this.search.DH,
                    GYSBH: this.search.GYSMC,
                    SBMC: this.search.SBMC,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    SHZT: this.search.SHZT,
                    Store: this.$UserInfo.StoreCode,
                    Token: '123456789'
                }).then(result => {
                    this.Total = result.Total;
                    var that = this;
                    result.RKList.map((item) => {
                        that.list.push(item);
                    });
                    if ((this.pageIndex * 10) >= result.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                });
            },
            serach() {
                this.list = [];
                this.pageIndex = 1;
                this.loadDataDefault();
                this.$Bus.$emit('IsSee', false);
            },
            refresh() {
                // 供父组件 putInStorage 切换 tab 时主动调用
                this.list = [];
                this.pageIndex = 1;
                this.loading = true;
                this.finished = false;
                this.loadDataDefault();
            },
            onSHZTChange(label) {
                this.search.SHZTLabel = label;
                const map = { '全部': '', '待审核': '0', '已审核': '1' };
                this.search.SHZT = map[label] !== undefined ? map[label] : '';
            },
            auditItem(item, index) { // 审核
                this.$Dialog.confirm({
                    message: `确定审核单号【${item.DH}】?`
                }).then(() => {
                    this.$get('api/CheckIncoming/AuditRKInfo', {
                        Token: '123456789',
                        DH: item.DH
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message: '审核成功!',
                                duration: 1500,
                                onClose: () => {
                                    // 审核后更新状态，无需从列表移除
                                    this.$set(this.list[index], 'SHZT', '1');
                                }
                            });
                        } else this.$Toast(result.Msg);
                    });
                }).catch(() => {});
            },
            viewDetail(item) { // 明细 → 跳转入库明细列表页
                this.$router.push({
                    name: 'RKDetailInfo',
                    params: { DH: item.DH }
                });
            },
            onLoad() { // 触底加载
                if (!this.finished && !this.loading) {
                    this.loading = true;
                    this.pageIndex += 1;
                    this.loadDataDefault();
                }
            }
        },
        watch: {
            $route(to, from) {
                if (from.name === 'EquipmentAcceptanceDetails' || from.name === 'RKDetailInfo') {
                    this.pageIndex = 1;
                    this.list = [];
                    this.loadDataDefault();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        margin-top: 12vw;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;

                    &.statusPass {
                        color: #52c41a;
                    }

                    &.statusWait {
                        color: #faad14;
                    }
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 20px;

            div {
                min-width: 140px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                padding: 0 20px;
                box-sizing: border-box;
            }

            .btn-audit {
                background: #ff9c00;
                color: #fff;
            }

            .btn-detail {
                background: $THEME-COLOR;
                color: #fff;
            }

            .btn-print {
                background: #dedede;
                color: #858585;
            }

            .btn-reconcile {
                background: $THEME-COLOR;
                color: #fff;
            }
        }
    }

    .listLength {
        top: 25vw !important;
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: -580px;
        margin-left: 30px;
        transition: all .5s;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/PutInStorage/YrkList.vue